module.exports = __webpack_public_path__ + "img/copy-icon.5c04f89a.svg";